/* eslint-disable */
function ExportToCSV(filterType, url) {
    let table = document.getElementById(filterType);

    if (!table) {
        console.error(`Table with ID "${filterType}" not found.`);
        return;
    };

    let rows = table.querySelectorAll('tr');
    let csvContent = "";

    rows.forEach(row => {
        let cols = row.querySelectorAll('th, td');
        let rowData = [];

        cols.forEach(col => {
            let cellText = col.innerText.replace(/,/g, ''); // Escape double quotes
            if(cellText !== "" && cellText !== "Action") {
                rowData.push(`${cellText}`); // Wrap each cell in quotes
            };
        });

        if (rowData.length > 0) {
            csvContent += rowData.join(",") + "\n";
        };
    });
    
    let blob = new Blob([csvContent], { type: 'text/csv' });
    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filterType + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default ExportToCSV;